<template>
    <div>
        <v-banner
            id="view-banner"
            :style="{ 'font-family': cookie.fontFamily }"
            v-if="cookie.type === 'banner'"
            :cookie="cookie"
            :nonFixed="nonFixed"
            @showAdjust="showAdjust"
        />
        <v-float
            id="view-float"
            :style="{ 'font-family': cookie.fontFamily }"
            v-if="cookie.type === 'float'"
            :cookie="cookie"
            :nonFixed="nonFixed"
            @showAdjust="showAdjust"
        />
        <v-modal
            id="view-modal"
            :style="{ 'font-family': cookie.fontFamily }"
            v-if="cookie.type === 'modal'"
            :cookie="cookie"
            :nonFixed="nonFixed"
            @showAdjust="showAdjust"
        />
        <v-popup
            id="view-popup"
            :style="{ 'font-family': cookie.fontFamily }"
            v-if="cookie.type === 'popup'"
            :cookie="cookie"
            :nonFixed="nonFixed"
            @showAdjust="showAdjust"
        />
        <div :style="{ display: 'none' }" class="easy-cookie hide">
            <AdjustBody
                id="adjust"
                :style="{ 'font-family': cookie.fontFamily }"
                :cookie="cookie"
                :nonFixed="nonFixed"
            />
        </div>
    </div>
</template>

<script>
import { COOKIE_PREVIEW_KIND } from "@/apps/cookie/cookie.routes";
import vBanner from "./vBanner.vue";
import vFloat from "./vFloat.vue";
import vModal from "./vModal.vue";
import vPopup from "./vPopup.vue";
import AdjustBody from "./AdjustBody.vue";
export default {
    name: "Cookie",
    components: {
        vBanner,
        vFloat,
        vModal,
        vPopup,
        AdjustBody,
    },
    props: {
        cookie: Object,
        nonFixed: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["updateIframeView"],
    methods: {
        showAdjust() {
            this.$emit("updateIframeView", COOKIE_PREVIEW_KIND.adjust);
        },
    },
};
</script>
